import type {
	ShopDto,
	UpdateOneGorgiasIntegrationDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateGorgiasIntegration(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/integrations/gorgias",
		{
			invalidate: invalidateShop,
			mapVariables: (requestBody: UpdateOneGorgiasIntegrationDto) => ({
				params: { path: { shopId: shop.id } },
				body: requestBody,
			}),
		},
	);
}
